import React, { useRef, useEffect, useState } from "react";

import useHttp from "../../../../hooks/use-http";

import moment from "moment";
import convertToExcel from "../../../../components/ExportToExcel";
import Pagination from "../../../../components/Pagination";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

const CropObservationReport = () => {
  const frmRef = useRef({});
  const navigate = useNavigate();
  const handleButtonClick = () => {
    navigate("/farmerwise");
  };
  const [employeeId, setEmployeeId] = useState();
  const [employeeData, setEmployeeData] = useState([]);
  const [employeeAllData, setEmployeeAllData] = useState([]);
  const [regionId, setRegionId] = useState();
  const [regionData, setRegionData] = useState([]);
  const [seasonId, setSeasonId] = useState("");
  const [seasonData, setSeasonData] = useState([]);
  const [ranchId, setRanchId] = useState();
  const [ranchData, setRanchData] = useState([]);



  const [collectionCenterId, setCollectionCenterId] = useState();
  const [collecticnCenterdata, setCollectionCenter] = useState([]);
  const [data, setData] = useState([]);

  const [itemsPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = data && data.slice(indexOfFirstItem, indexOfLastItem);
  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
  };
  const { sendRequest: getWarehouseData } = useHttp();

  const [cropAreaData, setCropAreaData] = useState([]);

  const [cropwiseAreaCovered, setcropwiseAreaCovered] = useState([]);
  const [executivewiseProcurement, setexecutivewiseProcurement] = useState([]);
  const [executivewiseAreaCovered, setexecutivewiseAreaCovered] = useState([]);

  const [selectedDate, setSelectedDate] = useState(
    new Date().toISOString().substr(0, 10)
  );

  const handleFDateChange = (e) => {
    //console.log("handleFDateChange",e.target.value)
    setSelectedFromDate(e.target.value);
  };
  const handleTDateChange = (e) => {
    setSelectedToDate(e.target.value);
  };

  // var date =date.setDate(date.getDate() + 10);

  const currentDate = new Date().toISOString().slice(0, 10);
  var d = new Date();
  d.setDate(d.getDate() - 15);

  const fromDate = d.toISOString().slice(0, 10);
  const [selectedFromDate, setSelectedFromDate] = useState(fromDate);

  const toDate = new Date().toISOString().slice(0, 10);

  //console.log("toDate",toDate)

  const [selectedToDate, setSelectedToDate] = useState(toDate);

  const { sendRequest: getprocurementData } = useHttp();

  const { sendRequest: getfarmerdeal } = useHttp();
  const { sendRequest: getSeasonList } = useHttp();


  const loadCountData = (id) => {
    fillprocurementData(id);
  };

  const fillprocurementData = (employeeId, regionId, ranchId) => {
    var newList = [];

    var urlfilter = "";

    var urlfilter = "";

    // urlfilter = urlfilter + `&fromDate=${selectedFromDate}`;
    // urlfilter = urlfilter + `&toDate=${selectedToDate}`;

    urlfilter =
      urlfilter +
      `&fromDate=${moment(frmRef.current.fromDate.value).format("DD/MM/YYYY")}`;

    urlfilter =
      urlfilter +
      `&toDate=${moment(frmRef.current.toDate.value).format("DD/MM/YYYY")}`;

    // console.log("urlfilter", urlfilter);

    if (employeeId > 0) {
      urlfilter = urlfilter + `&fieldExecutiveId=${employeeId}`;
    }

    if (regionId > 0) {
      urlfilter = urlfilter + `&regionId=${regionId}`;
    }
    if (ranchId > 0) {
      urlfilter = urlfilter + `&ranchId=${ranchId}`;
    }
    if (seasonId) {
      urlfilter = urlfilter + `&seasonId=${seasonId}`;
    }


    var url = `/api/farmerCropObservationReport/?orgId=${localStorage.getItem(
      "orgId"
    )}&&empId=${localStorage.getItem("empId")}${urlfilter} `;

    getprocurementData({ url: url }, (data) => {
      if (data && data.length > 0) {
        // Sort ascending by farmerName (you can change the key as required)
        const sortedData = data.sort((a, b) =>
          a.farmerName.localeCompare(b.farmerName)
        );

        setData(sortedData);
        setCurrentPage(1);
      } else {
        setData([]);
        setCurrentPage(1);
      }
    });
  };

  useEffect(() => {
    fillprocurementData(0, 0);
  }, []);

  const fieldsToExport = [
    "farmerName",
    "farmerNo",
    "executiveName",
    "regionName",
    // "stationName",
    // "areaName",
    "farmerStatus",
    "cropType",
    "cropName",
    "varietyName",
    // "growthType",
    "plotArea",
    "plotAreaUnit",
    // "landPreparationType",
    "timeOfApplication",
    // "fieldOperationDate",
    // "fieldOperationName",
    // "fieldOperationDescription",
    // "sowingMethod",
    // "seedSource",
    // "insectDiseasePestName",
    // "recommendationDate",
    // "recommendationByName",
  ];

  const customHeaders = [
    "Farmer Name",
    "Farmer Code",
    "Executive Name",
    "Region Name",
    // "Station Name",
    // "Area Name",
    "Farmer Status",
    "crop Type",
    "Crop Name",
    "Variety Name",
    // "Growth Type",
    "Plot Area",
    "Plot Size Unit",
    // "Land Preparation Type",
    "Time Of Application",
    // "Field Operation Date",
    // "Field Operation",
    // "Field Operation Description",
    // "Sowing Method",
    // "Seed Source",
    // "Insect/Disease/Pest Name",
    // "Recommendation Date",
    // "Recommendation By",
  ];

  const handleExportExcel = () => {
    if (!data || data.length === 0) {
      toast.error("No data available to export!");
      return;
    }
    const filename = "CropObservationReport.xlsx";
    //console.log(fieldsToExport,customHeaders);

    convertToExcel(data, fieldsToExport, filename, customHeaders);
  };

  const { sendRequest: getEmp } = useHttp();

  const EmployeeDetail = (region) => {
    var urlfilter = "";

    if (region > 0) {
      urlfilter = urlfilter + `&regionId=${region}`;
    }
    getEmp(
      {
        url: `/api/fillEmployeeForReortwithCase/?useCase=Procurement&empId=${localStorage.getItem(
          "empId"
        )}&orgId=${localStorage.getItem("orgId")}${urlfilter} `,
      },
      (data) => {
        console.log("emp", data);
        var emplist = data;

        setEmployeeData(emplist);
        setEmployeeAllData(emplist);
      }
    );
  };

  useEffect(() => {
    EmployeeDetail(0);
  }, [getEmp]);

  const { sendRequest: getRanch } = useHttp();
    useEffect(() => {
      getRanch(
        {
          url: `/api/ranchDetail/?orgId=${localStorage.getItem("orgId")}`,
        },
        (data) => {
          setRanchData(data);
        }
      );
    }, [getRanch]);

  // const { sendRequest: getRegion } = useHttp();
  // useEffect(() => {
  //   getRegion(
  //     {
  //       url: `/api/procurementRegionList/?orgId=${localStorage.getItem(
  //         "orgId"
  //       )}`,
  //     },
  //     (data) => {
  //       //console.log("region", data);

  //       setRegionData(data);
  //     }
  //   );
  // }, [getRegion]);

  useEffect(() => {
    getSeasonList(
      { url: `/api/seasons/?orgId=${localStorage.getItem("orgId")}` },
      (data) => {
        console.log("Season API Response:", data);
        setSeasonData(data);
      }
    );
  }, [getSeasonList]);


  return (
    <>
      <div className="content-wrapper">
        <div className="row mx-2">
          {" "}
          <div className="col-md-8 mt-3">
            {" "}
            <label className="card-title mx-3">
              Farmer Crop Observation Detail Reports
            </label>
          </div>
          <div className="col-md-4 text-right mt-3">
            <button
              type="button"
              className="btn btn-tool"
              data-card-widget="remove"
              onClick={handleButtonClick}
            >
              <i className="fas fa-times" />
            </button>
          </div>
        </div>
        <section className="content">
          <div className="container-fluid">
            <div className="row">
              {" "}
              <br />
            </div>
            <div className="row"></div>
            <div className="row">
              <div className="col-md-3">
                <div className="form-group">
                  <label>Ranch</label>
                  <select
                    id="ranch"
                    className="form-control"
                    value={ranchId}
                    onChange={(e) => setRanchId(Number(e.target.value) || 0)}
                  >
                    <option value="">Select</option>
                    {ranchData &&
                      ranchData.map((x) => (
                        <option key={x.ranchId} value={x.ranchId}>
                          {x.ranchName}
                        </option>
                      ))}
                  </select>
                  {/* <label>Region</label> */}
                  {/* <select
                    id="regionId"
                    className="form-control"
                    ref={(el) => (frmRef.current["regionId"] = el)}
                    value={regionId}
                    onChange={(e) => {
                      var regid = 0;

                      if (e.target.value != "--Select--") {
                        regid = e.target.value;
                      }
                      setRegionId(regid);
                      EmployeeDetail(regid);
                      setEmployeeId(0);
                      setData([]);
                    }}
                  >
                    <option>--Select--</option>
                    {regionData &&
                      regionData.map((x) => (
                        <option
                          key={x.regionId}
                          user-id={x.regionId}
                          value={x.regionId}
                        >
                          {x.regionName}
                        </option>
                      ))}
                  </select> */}
                </div>
              </div>
              <div className="col-md-3">
                <div className="form-group">
                  <label>
                    Executive Officer
                  </label>
                  <select
                    id="emp_id"
                    className="form-control"
                    ref={(el) => (frmRef.current["emp_id"] = el)}
                    value={employeeId}
                    onChange={(e) => {
                      var userid = 0;
                      if (e.target.value != "--Select--")
                        userid = e.target.value;

                      setEmployeeId(userid);
                      setData([]);
                    }}
                  >
                    <option>--Select--</option>
                    {employeeData &&
                      employeeData.map((x) => (
                        <option
                          key={x.userId}
                          user-id={x.userId}
                          value={x.userId}
                        >
                          {x.employeeName}
                        </option>
                      ))}
                  </select>
                </div>
              </div>

              <div className="col-md-3">
                <div className="form-group">
                  <label htmlFor="seasonName">Season Name</label>
                  <select
                    id="seasonName"
                    className="form-control"
                    ref={(el) => (frmRef.current["seasonName"] = el)}
                    value={seasonId}
                    onChange={(e) => {
                      setSeasonId(e.target.value);
                      setData([]);
                    }}
                  >
                    <option value="">--Select--</option>

                    {seasonData &&
                      seasonData.map((x) => (
                        <option key={x.seasonId} value={x.seasonId}>
                          {x.seasonName}
                        </option>
                      ))}
                  </select>
                </div>
              </div>



              <div className="col-md-2">
                <div className="form-group">
                  {" "}
                  <label htmlFor={"from_date"}>{"From Date"}</label>
                  <input
                    type={"date"}
                    id={"date"}
                    required
                    ref={(el) => (frmRef.current["fromDate"] = el)}
                    className="form-control"
                    max={currentDate}
                    value={selectedFromDate}
                    onChange={handleFDateChange}
                  />
                </div>
              </div>
              <div className="col-md-2">
                <div className="form-group">
                  <label htmlFor={"to_date"}>{"To Date"}</label>

                  <input
                    type={"date"}
                    id={"date"}
                    required
                    ref={(el) => (frmRef.current["toDate"] = el)}
                    className="form-control"
                    max={currentDate}
                    value={selectedToDate}
                    onChange={handleTDateChange}
                  />
                </div>
              </div>
              <div className="col-md-2">
                <div className="form-group">
                  <label>&nbsp;</label>
                  <button
                    className="form-control btn btn-sm btn-primary"
                    onClick={(e) => {
                      fillprocurementData(employeeId, regionId, ranchId);
                    }}
                  >
                    Submit
                  </button>
                </div>
              </div>
            </div>
          </div>
          <h5>Please select the parameters to get the desired result</h5>
          <hr />
        </section>

        <section className="content">
          <div className="container-fluid">
            <div className="text-right my-2">
              <button
                type="button"
                className="btn btn-sm btn-warning"
                onClick={handleExportExcel}
              >
                <i className="fas fa-file-excel"></i>
              </button>
            </div>
            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body" style={{ padding: "0.4rem" }}>
                    <table className="table table-bordered table-responsive text-center table-sm">
                      <thead>
                        <tr className="tableheaderrowview">
                          <th>Farmer Name</th>
                          <th>Farmer Code</th>
                          <th>Executive Name</th>
                          <th>Ranch Name</th>
                          {/* <th>Station Name</th>
                          <th>Area Name</th> */}
                          <th>Farmer Status</th>
                          <th>Season Name</th>

                          <th>Crop Type</th>
                          <th>Crop Name</th>
                          <th>Variety Name</th>
                          {/* <th>Growth Type</th> */}

                          <th>Plot No.</th>
                          <th>Plot Area</th>
                          <th>Plot Size Unit</th>
                          {/* <th>Land Preparation Type</th> */}
                          <th>Time Of Application</th>
                          {/* <th>Field Operation Date</th> */}
                          <th>Field Operation</th>

                          {/* <th>Field Operation Description</th> */}
                          {/* <th>Sowing Method</th> */}
                          {/* <th>Seed Source</th> */}
                          {/* <th>Insect/Disease/Pest Name</th> */}

                          {/* <th>Recommendation Date</th>
                          <th>Recommendation By</th> */}
                        </tr>
                      </thead>

                      <tbody>
                        {currentItems &&
                          currentItems.map((itm, i) => {
                            return (
                              <tr key={i} className="tablerowview">
                                <td>{itm.farmerName}</td>
                                <td>{itm.farmerNo}</td>
                                <td>{itm.executiveName}</td>
                                <td>{itm.ranchName}</td>
                                {/* <td>{itm.stationName}</td>
                                <td>{itm.areaName}</td> */}
                                <td>{itm.farmerStatus} </td>
                                <td>{itm.seasonName} </td>

                                <td>{itm.cropType}</td>
                                <td>{itm.cropName}</td>
                                <td>{itm.varietyName}</td>
                                {/* <td> {itm.growthType} </td> */}
                                <td> {itm.plotName} </td>
                                <td> {itm.plotArea} </td>
                                <td> {itm.plotAreaUnit} </td>
                                {/* <td> {itm.landPreparationType} </td> */}
                                <td> {itm.timeOfApplication} </td>
                                {/* <td> {itm.fieldOperationDate} </td> */}
                                <td> {itm.fieldOperationName} </td>
                                {/* <td> {itm.fieldOperationDescription} </td>
                                <td> {itm.sowingMethod || ""} </td>
                                <td> {itm.seedSource || ""} </td>
                                <td> {itm.insectDiseasePestName} </td>
                                <td> {itm.recommendationDate} </td>
                                <td> {itm.recommendationByName} </td> */}
                              </tr>
                            );
                          })}
                      </tbody>
                    </table>
                  </div>

                  <div className="card-footer clearfix">
                    <Pagination
                      totalItems={data.length}
                      itemsPerPage={itemsPerPage}
                      onPageChange={paginate}
                      currentPage={currentPage}
                      setCurrentPage={setCurrentPage}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default CropObservationReport;
